import { render, staticRenderFns } from "./TwoWayControls.vue?vue&type=template&id=3124ea4d&scoped=true"
import script from "./TwoWayControls.vue?vue&type=script&lang=js"
export * from "./TwoWayControls.vue?vue&type=script&lang=js"
import style0 from "./TwoWayControls.vue?vue&type=style&index=0&id=3124ea4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3124ea4d",
  null
  
)

export default component.exports